<template>
  <div style="padding:500px">
    <button @click="startRecord" :disabled="isRecording">开始录音</button>
    <button @click="stopRecord" :disabled="!isRecording">手动停止</button>
    <p>当前音量: {{ volume.toFixed(4) }}</p>
    <p v-if="isSilent" style="color: orange;">检测到持续静音，即将停止...</p>
  </div>
</template>

<script>
// 如果你用 npm 安装了 recorder-core
import Recorder from 'recorder-core';
import 'recorder-core/src/engine/pcm.js'
import axios from 'axios'

export default {
  data() {
    return {
      rec: null,
      isRecording: false,
      volume: 0,
      silentCount: 0,
      isSilent: false,
      silenceThreshold: 0.01,     // 静音阈值
      maxSilentFrames: 50,        // 连续静音帧数（约 3 秒）
      sampleRate: 16000,
      audioBlob: null,             // 保存录音的 Blob，用于下载或上传
      startTime: ''
    };
  },
  methods: {
    async startRecord() {
      if (this.isRecording) return;

      try {
        const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
        this.rec = Recorder({
          type: 'pcm',
          sampleRate: this.sampleRate,
          bitRate: 16,
          onProcess: (buffers, powerLevel) => {
            this.volume = powerLevel;
            this.checkSilence(powerLevel);
          }
        });

        this.rec.open(
          () => {
            this.rec.start();
            this.isRecording = true;
            this.silentCount = 0;
            this.isSilent = false;
            console.log('录音已开始');
            this.startTime = Date.now()
          },
          (msg) => {
            alert('录音初始化失败：' + msg);
            console.error('Recorder open error:', msg);
          },
          stream
        );
      } catch (err) {
        alert('请允许麦克风权限');
        console.error('获取麦克风失败:', err);
      }
    },

    checkSilence(powerLevel) {
      if (powerLevel < this.silenceThreshold) {
        this.silentCount++;
        if (this.silentCount >= this.maxSilentFrames && this.isRecording) {
          this.isSilent = true;
          this.stopRecord(); // 自动停止
        }
      } else {
        this.silentCount = 0;
        this.isSilent = false;
      }
    },

    stopRecord() {
      if (!this.rec || !this.isRecording) return;

      this.rec.stop((blob) => {
        this.isRecording = false;
        this.audioBlob = blob; // 保存 blob

        console.log('录音已停止，生成 PCM Blob');

        // 👇 下载 PCM 文件
        this.downloadPcm(blob);

        // 👇 可选：上传到服务器
        this.uploadPcm(blob);
      }, (msg) => {
        console.error('录音停止出错:', msg);
      });
    },

    // 💾 下载 PCM 文件
    downloadPcm(blob) {
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `recording_${Date.now()}.pcm`; // 文件名
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url); // 释放内存
    },

    // 📤 上传 PCM（可选）
    uploadPcm(blob) {
      const formData = new FormData();
      // 注意：PCM 是无头原始音频，服务端需知道采样率等参数
      formData.append('file', blob, 'record.pcm');
      formData.append('userId', '亚克卓玛');
      formData.append('index', this.startTime.toString()); // FormData 只接受字符串或 Blob
      axios.post("api/api/comm/file/upload",formData).then(res => {
        if(res.code === 200){
          console.log("发送成功")
        }
      })
    }
  },

  beforeDestroy() {
    if (this.rec) {
      this.rec.close();
    }
  }
};
</script>